import React, { useEffect } from "react";
import { DEFAULT_TICKER_REFRESH_SECONDS, TOOL_TEMPLATE } from "../constant/common";
import { useCompanySettings, useInstrumentsSetting, useTemplateSetting } from "../hooks/useCompanySettings";
import useInstruments from "../hooks/useInstruments";
import MultipleTickerRadio from "./MultipleTickerRadio";
import MultipleTickerSlider from "./MultipleTickerSlider";

export default function MultipleTicker() {
  const template = useTemplateSetting();
  const [{ instruments }, { getInstruments }] = useInstruments();
  const instrumentsSetting = useInstrumentsSetting();
  const { tickerRefreshSeconds } = useCompanySettings();
  const refreshTmeOut = tickerRefreshSeconds || DEFAULT_TICKER_REFRESH_SECONDS;

  useEffect(() => {
    if (instrumentsSetting.length) {
      getInstruments(instrumentsSetting.map(i => i.id));
    }
    const interval = setInterval(() => {
      if (instrumentsSetting.length) {
        getInstruments(instrumentsSetting.map(i => i.id));
      }
    }, refreshTmeOut * 1000);
    return () => {
      clearInterval(interval);
    };
  }, [getInstruments, instrumentsSetting, refreshTmeOut]);
  if (instruments.length <= 1) return null;
  return (
    <div className="MultipleTicker">
      {template === TOOL_TEMPLATE.quadrata && <MultipleTickerRadio />}
      {template === TOOL_TEMPLATE.victor && <MultipleTickerSlider />}
    </div>
  );
}
